import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import Typography from '@mui/joy/Typography';

// components
import RouteTable from "./RouteTable";
import BaseApi from "../../utils/BaseApi";

class RouteList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            routes: [],
        };
    }

    async componentDidMount() {
        await this.retrieveRoutes();
    }

    async retrieveRoutes() {
        const url = 'route_state/my/';
        const api = new BaseApi();
        let response = await api.get(url, {});
        await this.setState(
            {
                routes: response.data.results
            }
        );
    }

    render() {
        if (!this.state.routes) {
            return (<CircularProgress/>)
        }
        return (
            <Stack>
                <Typography
                    level="h1"
                    fontSize="xl4"
                    sx={{'pb': 2}}
                >
                    Мои маршруты
                </Typography>
                <RouteTable
                    routes={this.state.routes}
                    callBack={this.retrieveRoutes.bind(this)}
                />
            </Stack>
        )
    }
}

export default RouteList;
